import React, { FC } from 'react'
import { mailroomStrings } from 'common/strings/mailroom-strings'
import Strings from 'project/localisation'
import TitledAccordion from 'components/TitledAccordion'
import PoweredByLogo from 'components/hero/PoweredByLogo'
import useWindowSize from 'components/util/useWindowSize'
import classNames from 'classnames'
import imageResize from 'project/image-proxy-web' // we need this to make JSX compile

type MailroomFeaturesSectionType = {}

const MailroomFeaturesSection: FC<MailroomFeaturesSectionType> = ({}) => {
  const size = useWindowSize()
  return (
    <>
      <TitledAccordion
        items={[
          {
            body: mailroomStrings.savesTimeSpaceMoneyDescription,
            title: mailroomStrings.savesTimeSpaceMoney,
          },
          {
            body: mailroomStrings.doesTheWorkFormYouDescription,
            title: mailroomStrings.doesTheWorkFormYou,
          },
          {
            body: mailroomStrings.latestTechnologyDescription,
            title: mailroomStrings.latestTechnology,
          },
          {
            body: mailroomStrings.goPaperlessDescription,
            title: mailroomStrings.goPaperless,
          },
          {
            body: mailroomStrings.worksNicelyWithOthersDescription,
            title: mailroomStrings.worksNicelyWithOthers,
          },
          {
            body: mailroomStrings.focusOnWhatsImportantDescription,
            title: mailroomStrings.focusOnWhatsImportant,
          },
          {
            body: mailroomStrings.beMoreAgileDescription,
            title: mailroomStrings.beMoreAgile,
          },
          {
            body: mailroomStrings.deRiskYourBusinessDescription,
            title: mailroomStrings.deRiskYourBusiness,
          },
        ]}
        image={require('public/images/mailroom/mailroom-page-mailroom-operations -desktop.png')}
        imageAlt={`${Strings.mailroom} icon`}
        title={`${mailroomStrings.managingMailroom}`}
        subtitle={`${mailroomStrings.managingMailroomDescription}`}
        paddingClasses={'mx-sm-0 mx-n4'}
        expandAllButtonMobileOnly={false}
        imageClasses={'my-md-0 my-8 img-mobile-fullwidth'}
      />
      <div className='mt-lg-22 mt-12 d-flex justify-content-center flex-column align-items-center'>
        <img
          loading='lazy'
          className='img-fluid'
          width={size.isLgOrHigher ? 684 : 335}
          alt={'Mailroom Logo'}
          src={imageResize(
            require('public/images/logos/mailroom-logo-red.svg'),
          )}
        />
        <PoweredByLogo
          width={size.isLgOrHigher ? 122 : 111}
          height={size.isLgOrHigher ? 36 : 20}
          fill={'black'}
          fill2={size.isLgOrHigher ? '#fff' : '#FDDD1C'}
          className='mt-lg-6 mt-2 mb-lg-13 mb-12'
        />
        <h3
          className={classNames(
            'text-center mb-0',
            size.isLgOrHigher
              ? 'h1 text-bold'
              : 'h2 text-semibold mx-sm-0 mx-n2',
          )}
          dangerouslySetInnerHTML={{
            __html: `${mailroomStrings.mailroomSlogan}`,
          }}
        />
        <div className='mt-4 px-lg-0 px-4'>
          <p className='text-xl text-semibold text-center'>
            Contact us at{' '}
            <a className='text-link color-red'>enterprise@hoxtonmix.com</a> to
            discuss a custom <br className={'d-md-block d-none'} /> Mailroom
            solution for your business.
          </p>
        </div>
      </div>
    </>
  )
}

export default MailroomFeaturesSection
